const Library = () => {
    return (
        <>
            <h1>Library Page</h1>
        </>
    )
}

export default Library;